import { createTheme } from '@mui/material/styles'
import { PaletteMode } from '@mui/material'
import { TypographyOptions } from '@mui/material/styles/createTypography'

export const paletteColorsDark = {
  primary: '#6694e9',
  primaryLight: '#8cb3ee',
  primaryDark: '#5073c8',
  textOnPrimary: '#000000',
  secondary: '#f9ea4f',
  secondaryLight: '#fcf17d',
  secondaryDark: '#ecbf3f',
  textOnSecondary: '#000000',
  error: '#cf6679',
  background: {
    default: '#000000',
    paper: '#1e2124',
    paperDark: '#121212',
  },
  text: '#bbe1fa',
}

export const paletteColorsLight = {
  primary: '#212121',
  primaryLight: '#484848',
  primaryDark: '#000000',
  textOnPrimary: '#ffffff',
  secondary: '#42a5f5',
  secondaryLight: '#80d6ff',
  secondaryDark: '#0077c2',
  textOnSecondary: '#000000',
  error: '#E44C65',
  background: {
    default: '#00030f',
    paper: '#303030',
  },
  text: '#050505',
}

const typographyTheme: TypographyOptions = {
  h1: {
    fontSize: 56,
    fontWeight: 700,
    lineHeight: '112px',
    letterSpacing: '-1.5px',
    /*, fontFamily: 'smileAndWave' */
  },
  h2: {
    fontSize: 46,
    fontWeight: 600,
    lineHeight: '72px',
    letterSpacing: '-0.5px',
    /*, fontFamily: 'smileAndWave' */
  },
  h3: {
    fontSize: 38,
    fontWeight: 500,
    lineHeight: '56px',
    letterSpacing: '0px',
    /*, fontFamily: 'smileAndWave' */
  },
  h4: {
    fontSize: 30,
    fontWeight: 400,
    lineHeight: '36px',
    letterSpacing: '0px',
  },
  h5: {
    fontSize: 24,
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.18px',
  },
  h6: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  subtitle1: {
    fontSize: 16,
    // fontWeight: 400,
    // lineHeight: '24px',
    // letterSpacing: '0.15px',
  },
  subtitle2: {
    fontSize: 14,
    // fontWeight: 500,
    // lineHeight: '24px',
    // letterSpacing: '0.1px',
  },
  body1: {
    fontSize: 16,
    // fontWeight: 400,
    // lineHeight: '24px',
    // letterSpacing: '0.5px',
  },
  body2: {
    fontSize: 14,
    // fontWeight: 400,
    // lineHeight: '20px',
    // letterSpacing: '0.25px',
  },
  button: {
    // textTransform: 'none'
  },
  fontFamily: [
    'Roboto',
    'Helvetica',
    'Arial',
    'sans-serif',
    'smileAndWave',
  ].join(','),
}

const options = (dark: boolean) => {
  let paletteColors = dark ? paletteColorsDark : paletteColorsLight
  return {
    palette: {
      mode: dark ? 'dark' : ('light' as PaletteMode),
      primary: {
        main: paletteColors.primary,
        light: paletteColors.primaryLight,
        dark: paletteColors.primaryDark,
        contrastText: paletteColors.textOnPrimary,
      },
      secondary: {
        main: paletteColors.secondary,
        light: paletteColors.secondaryLight,
        dark: paletteColors.secondaryDark,
        contrastText: paletteColors.textOnSecondary,
      },
      error: {
        main: paletteColors.error,
      },
      background: paletteColors.background,
    },
    typography: typographyTheme,
    components: {
      MuiCssBaseline: {
        styleOverrides: `
          @font-face {
            font-family: 'smileAndWave';
            font-style: 'normal';
            font-weight: 400;
            src: url("/fonts/smileandwave.ttf");
          }
      `,
      },
    },
  }
}
export const darkTheme = createTheme(options(true))
export const lightTheme = createTheme(options(false))

export default darkTheme
